

import React, { useEffect } from 'react'
import { Helmet } from 'react-helmet-async'
import { Link as RouterLink } from 'react-router-dom';
import { Box, Button, Card, Container, Fab, FormControl, InputLabel, MenuItem, Select, Stack, TextField, Typography } from '@mui/material'
import { KeyboardArrowLeftRounded } from '@mui/icons-material'
import dayjs from 'dayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';


function AddWorkLogPage() {
    const [value, setValue] = React.useState(dayjs(new Date()));
    const CurrentDateOfYear = `01/01/${new Date().getFullYear()}`;
    const NextDateOfYear = `12/31/${new Date().getFullYear() + 1}`;
    return (
        <>
            <Helmet>
                <title> Add Worklog | ABEPL </title>
            </Helmet>
            <Container maxWidth="xl">

                <Typography variant="h4" sx={{ mb: 2 }}>
                    <Fab component={RouterLink} to='/qualitydashboard/inspectionworkorder' size="small" aria-label="back" title='Back'>
                        <KeyboardArrowLeftRounded />
                    </Fab>  Add WorkLog
                </Typography>
                <Card sx={{ paddingLeft: '4%' }}>
                    <Stack spacing={2} sx={{ pt: 1 }}>
                        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} sx={{ pt: 1 }}>
                            <FormControl sx={{ paddingRight: '3%' }} >
                                <TextField fullWidth
                                    autoComplete="off"
                                    label="Comments"
                                    sx={{ paddingRight: '3%' }}
                                />
                            </FormControl>
                        </Stack>
                        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} sx={{ pt: 1 }}>
                            <FormControl sx={{paddingRight: '3%' }} >
                                <TextField fullWidth
                                    autoComplete="off"
                                    label="Changed By"
                                    sx={{ paddingRight: '3%' }}
                                />
                            </FormControl>
                        </Stack>
                        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} sx={{ pt: 1 }}>
                            <FormControl sx={{paddingRight: '3%' }} >
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <DatePicker
                                        label="Changed Timestamp"
                                        inputFormat="DD/MM/YYYY"
                                        value={value}
                                        onChange={(newValue) => {
                                            setValue(newValue);
                                        }}
                                        minDate={new Date(CurrentDateOfYear)}
                                        maxDate={new Date(NextDateOfYear)}
                                        renderInput={(params) => <TextField {...params} />}
                                        sx={{ paddingRight: '3%' }}
                                    />
                                </LocalizationProvider>
                            </FormControl>
                            </Stack>
                        </Stack>
                        &nbsp;
                        &nbsp;
                        <Box display='flex' alignItems="center" justifyContent="center">
                            <Button sx={{ minWidth: 120 }} variant="contained" >Submit</Button>
                            &nbsp;
                            &nbsp;
                            <Button sx={{ minWidth: 120, mr: 2 }} variant="outlined">Cancel</Button>

                        </Box>
                        &nbsp;
                        &nbsp;
                </Card>
            </Container>

        </>
    )
}

export default AddWorkLogPage